// Droppable subtask list panel body for TaskGroupSubtasks.
import { Box, Typography } from '@mui/material';
import TaskList from '@/features/tasks/components/lists/TaskListBase';
import TaskInputInline from '@/features/tasks/components/forms/TaskInputInline';
import { AddTaskRow, AddTaskInputRow } from '@/components/ui/AddTaskRow';

/**
 * @param {object} props
 */
export function TaskGroupSubtasksPanel({
  parentId,
  subtasks,
  droppableId,
  isOver,
  setNodeRef,
  isAddingSubtask,
  emptyStateMessage,
  showCompleted,
  incompleteSubtasks,
  completedSubtasks,
  sharedTaskListProps,
  handleBeforeToggleComplete,
  handleSave,
  onStartAdding,
  onCancelAdding,
  addSubtaskLabel,
}) {
  const showEmpty = subtasks.length === 0 && !isAddingSubtask;
  const showCompletedList = showCompleted && completedSubtasks.length > 0;

  return (
    <Box
      ref={droppableId ? setNodeRef : undefined}
      data-testid="panel-sub-tasks"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        border: '2px dashed',
        borderColor: 'divider',
        borderRadius: 1,
        transition:
          'background-color 0.2s ease-in-out, border-color 0.2s ease-in-out',
        minHeight: 100,
        position: 'relative',
        ...(showEmpty && {
          minHeight: 80,
          justifyContent: 'center',
          alignItems: 'center',
        }),
        ...(isOver && {
          backgroundColor: 'background.subtle',
          borderColor: 'primary.main',
        }),
      }}
    >
      {incompleteSubtasks.length > 0 ? (
        <TaskList
          id={`subtasks-of-${parentId}`}
          listId={`subtasks-of-${parentId}`}
          tasks={incompleteSubtasks}
          {...sharedTaskListProps}
          onBeforeToggleComplete={handleBeforeToggleComplete}
        />
      ) : null}
      {showEmpty ? (
        <Box
          sx={{
            textAlign: 'center',
            color: 'text.secondary',
            p: 2,
            pointerEvents: 'none',
          }}
        >
          <Typography>{emptyStateMessage}</Typography>
        </Box>
      ) : null}
      {isAddingSubtask ? (
        <AddTaskInputRow>
          <TaskInputInline
            dense={false}
            onSave={handleSave}
            onCancel={onCancelAdding}
          />
        </AddTaskInputRow>
      ) : null}
      {showCompletedList ? (
        <TaskList
          id={`completed-subtasks-of-${parentId}`}
          listId={`completed-subtasks-of-${parentId}`}
          tasks={completedSubtasks}
          {...sharedTaskListProps}
          isSortable={false}
        />
      ) : null}
      {!isAddingSubtask ? (
        <AddTaskRow label={addSubtaskLabel} onClick={onStartAdding} />
      ) : null}
    </Box>
  );
}
